import {isEmpty} from 'lodash';
import initialState from '../initialstate';
import {UserType, HttpStatusCodes, minDate} from '../../util/uiconstants';
import * as types from '../../actions/actiontypes';
import {labels} from '../../util/utils';

export default function EngagementMetricsReducer(state = initialState.engagementMetrics, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_METRICS: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let response = action.response;
				let availableEngagements = [];

				// normalize engagements data
				response.forEach((item) => {
					item.engDes = getEngagementDescription(action.userType, item);
					item.mS = item.mS?.map((m) => ({...m, engId: item.engId}));
					availableEngagements.push(item.engId);
				});

				// If engagement metric API response not contains some engagement details, show dummy data for those engagements
				let unavailableEngagements = action.selectedEngagements.filter(
					(eng) => availableEngagements.indexOf(eng) === -1
				);
				unavailableEngagements.forEach((engId) => response.push(getEngagementDummyData(engId)));
				const _state = {...state};
				_state[action.metricId] = response;

				return _state;
			}

			return state;
		}
		case types.CLEAN_ENGAGEMENT_METRICS: {
			return initialState.engagementMetrics;
		}
		default:
			return state;
	}
}

function getEngagementDescription(userType, engagement) {
	const isExternalMember = userType !== UserType.Member;

	if (isExternalMember && !isEmpty(engagement.cliEngDes)) {
		return engagement.cliEngDes;
	} else {
		return engagement.engDes;
	}
}

const getEngagementDummyData = (engId) => {
	return {
		engKey: engId,
		engId: engId,
		engDes: labels.recordsNotAvailable,
		cliEngDes: labels.recordsNotAvailable,
		relDate: '2020-03-23T23:59:59',
		loadedOn: minDate,
		allTC: 0,
		allTO: 0,
		allTIR: 0,
		allTIP: 0,
		allTTot: 0,
		arcRepQlf: 0,
		arcRepQlfType: 0,
		gAType: 0,
		partInv: true,
		hasAPPICSO: false,
		hasCRAPICSO: false,
		isEQREng: false,
		isEQRInv: false,
		prDigtalGam: 348,
		hasAPEQRSO: false,
		hasCRAEQRSO: false,
		isPartInvDlyd: false,
		isPartCRASODlyd: false,
		isPartAPSODlyd: false,
		isEQRCRASODlyd: false,
		cRNotSent: 0,
		cRReceived: 0,
		cRAccepted: 0,
		cRRetrn: 0,
		cRPendResp: 0,
		cRTotal: 0,
		cROD: 0,
		cRAvgDays: 0.0,
		cRDueTom: 0,
		cRDue3: 0,
		cRDue5: 0,
		cRDue10: 0,
		cRDue30: 0,
		pTTotal: 0,
		pTOpen: 0,
		pTInProg: 0,
		pTInRev: 0,
		pTCompl: 0,
		pTOD: 0,
		pTRetrn: 0,
		cTTotal: 0,
		cTNotSent: 0,
		cTPartialSend: 0,
		cTComplSend: 0,
		cTOD: 0,
		cTRetrn: 0,
		cTUnlinkTot: 0,
		pATot: 0,
		pAUnAsgn: 0,
		pAOpen: 0,
		pAInProg: 0,
		pACompld: 0,
		pAOpenOD: 0,
		pAInProgOD: 0,
		rA: 0,
		rAUnAsgn: 0,
		rANotStart: 0,
		rAInProg: 0,
		rACompld: 0,
		rANotStartOD: 0,
		rAInProgOD: 0,
		rNTotal: 0,
		rNO: 0,
		rNOLow: 0,
		rNOMed: 0,
		rNOHigh: 0,
		rNOCrit: 0,
		rNOLowOD: 0,
		rNOMedOD: 0,
		rNOHighOD: 0,
		rNOCritOD: 0,
		rNCLow: 0,
		rNCMed: 0,
		rNCHigh: 0,
		rNCCrit: 0,
		rNCloLow: 0,
		rNCloMed: 0,
		rNCloHigh: 0,
		rNCloCrit: 0,
		riskTotal: 0,
		riskInherent: 0,
		riskSigni: 0,
		riskFraud: 0,
		sTTotal: 0,
		sTOpen: 0,
		sTInProg: 0,
		sTInRev: 0,
		sTClo: 0,
		subPsp: 0,
		subOsp: 0,
		subHxPsp: 0,
		conTotal: 0,
		conTested: 0,
		conTaskTotal: 0,
		conTaskOpen: 0,
		conTaskInProg: 0,
		conTaskInRev: 0,
		conTaskClo: 0,
		wTTTotal: 0,
		wTTOpen: 0,
		wTTInProg: 0,
		wTTInRev: 0,
		wTTClo: 0,
		defOper: 0,
		defDesign: 0,
		defOperAndDes: 0,
		sDOper: 0,
		sDDesign: 0,
		sDOperAndDes: 0,
		mWOper: 0,
		mWDesign: 0,
		mWOperAndDes: 0,
		misCor: 0,
		misUnCor: 0,
		misFactCY: 0,
		misProjCY: 0,
		misJudgCY: 0,
		misReclasCY: 0,
		itConTested: 0,
		itConTotal: 0,
		itConSubTested: 0,
		itConSubTotal: 0,
		mS: [
			{
				engKey: engId,
				engId: engId,
				tPTId: 1,
				aPId: 0,
				dO: 0,
				tT: 0,
				tO: 0,
				tIP: 0,
				tIR: 0,
				tC: 0,
				pCG: '0%',
				pC: 0,
				pNOP: '0 %',
				pNO: 0.0,
				sD: '0001-01-01T00:00:00',
				eD: '0001-01-01T00:00:00',
				tNOD: 0,
				tIPOD: 0,
				tIROD: 0
			}
		]
	};
};
